import { useEffect, useRef, useState } from "react";
import { useHitFx } from "./fx";

export const HitSkeletonCard = () => (
  <div className="hl-skel" aria-hidden data-testid="hit-skeleton-card">
    <div className="hl-skel-img"><div data-fx="sheen" className="hl-skel-sheen" /></div>
    <div className="hl-skel-title" />
    <div className="hl-skel-price" />
  </div>
);

const useCols = () => {
  const q = "(min-width: 1024px)";
  const [desk, setDesk] = useState(() => window.matchMedia(q).matches);
  useEffect(() => {
    const m = window.matchMedia(q);
    const f = () => setDesk(m.matches);
    m.addEventListener("change", f);
    return () => m.removeEventListener("change", f);
  }, []);
  return desk;
};

// Grilla de esqueletos: móvil 2×2, desktop 4×2. `className` puede reemplazar la grilla.
export function HitSkeletonGrid({ className, rows = 2, desktopCols = 4 }) {
  const cols = useCols() ? desktopCols : 2;
  const rootRef = useRef(null);
  const stateRef = useRef({ progress: null, steps: [] });
  useHitFx(rootRef, stateRef);
  return (
    <div ref={rootRef} className={className || "hl-skel-grid"} data-testid="hit-skeleton-grid">
      {Array.from({ length: cols * rows }, (_, i) => <HitSkeletonCard key={i} />)}
    </div>
  );
}
